import { AlertCircle } from 'lucide-react';

export function LoadingState({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="async-state" role="status">
      <span aria-hidden="true" className="legacy-loader" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ error, retry }: { error: unknown; retry?: () => void }) {
  const message = error instanceof Error ? error.message : 'Не удалось загрузить данные';
  return (
    <div className="async-state async-state--error" role="alert">
      <AlertCircle size={22} />
      <span>{message}</span>
      {retry ? (
        <button className="button button--secondary" onClick={retry} type="button">
          Повторить
        </button>
      ) : null}
    </div>
  );
}
